import React, { Component } from "react";
import { Link } from "react-router-dom";
// import PropTypes from "prop-types";

export class Contact extends Component {
  static propTypes = {};

  render() {
    return (
      <div>
        <section className="banners">
          <div className="container">
            <div className="banner-info">
              <h6>
                <Link to="home">Home</Link> | <Link to=""></Link> Contact
              </h6>
              <h2>Contact</h2>
            </div>
          </div>
        </section>

        <section className="contact">
          <div className="container">
            <div className="contact-info">
              <div className="heading">
                <h1>contact Information</h1>
                <div className="wrap_address">
                  <ul>
                    <li>
                      <span>Address:</span>Tirath Mansion, 5, Mahatma Gandhi{" "}
                      <br />
                      Main Rd, Ranchi, Jharkhand 834001
                    </li>
                    <li>
                      <span>Font Office :</span> 9102994158
                      <span>Management :</span> 9431109245, 7908538352
                    </li>
                    <li>
                      <span>Email:</span> info@hotelpalashresidency.com
                    </li>
                  </ul>
                </div>
              </div>
              <div className="forms-cont">
                <form action="">
                  <input type="text" name="" id="" placeholder="Name" />
                  <br />
                  <input type="text" name="" id="" placeholder="Email" />
                  <br />
                  <input type="text" name="" id="" placeholder="Subject" />
                  <br />
                  <textarea
                    type="text"
                    name=""
                    id=""
                    placeholder="Message"
                  ></textarea>
                  <br />
                  <button>Send Message</button>
                </form>
                <iframe
                  src="https://www.google.com/maps/place/Hotel+Palash+Residency,+Banquet+Hall+(Weddingz.in+Partner)/@23.3513292,85.3234187,17z/data=!3m1!4b1!4m5!3m4!1s0x39f4e103f1011e7f:0x685da98d27b8ac8d!8m2!3d23.3513243!4d85.3256074"
                  width="600"
                  height="450"
                  loading="lazy"
                  title="map"
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Contact;
